import { MIMETYPE_JSON } from '@disy/lib/media-type';

import { ajax, encodePathVariable } from 'cadenza/api-client/api';
import type { StylePropertyValue } from 'cadenza/api-client/model/style-property-value';
import { createWorkbookUrl } from 'cadenza/api-client/workbook-api';
import type { WorkbookNameAndHash } from 'cadenza/repository/model/workbook-name-and-hash';
import type { AttributeId } from 'cadenza/workbook/model/attribute-id.gen';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import type {
  IntervalClassificationClassDto,
  IntervalClassificationParametersDto,
  MinMax,
} from 'cadenza/workbook/model/interval-classification-model';

export async function getMeasureMinMax(
  workbookNameAndHash: WorkbookNameAndHash,
  dataViewId: DataViewId,
  attributeId: AttributeId,
  signal: AbortSignal,
) {
  const url = `${createWorkbookUrl(workbookNameAndHash)}/attributes/${encodePathVariable(attributeId)}/min-max?dataViewId=${dataViewId}`;
  const minMax = await ajax<MinMax | null>(url, { signal });
  return minMax ?? undefined;
}

export interface IntervalClassificationDto<T extends StylePropertyValue> {
  classifications: IntervalClassificationClassDto<T>[];
  truncated: boolean;
}

export function getIntervalClassifications<T extends StylePropertyValue>(
  workbookNameAndHash: WorkbookNameAndHash,
  attributeId: AttributeId,
  classificationParams: IntervalClassificationParametersDto,
  signal: AbortSignal,
) {
  const url = `${createWorkbookUrl(workbookNameAndHash)}/attributes/${btoa(attributeId)}/interval-classification`;
  return ajax<IntervalClassificationDto<T>>(url, {
    method: 'PUT',
    contentType: MIMETYPE_JSON,
    data: JSON.stringify(classificationParams),
    signal,
  });
}
